import { RouterModule, Routes } from '@angular/router';

import { FlightTrackerComponent } from './flight-tracker.component';

const routes: Routes = [
  {
    path: '',
    component: FlightTrackerComponent,
    data: { pageName: 'Flight Tracker' },
  },
  {
    path: ':By/:Origin/:Destination/:Date',
    component: FlightTrackerComponent,
    data: { pageName: 'Flight Tracker' },
  },
  {
    path: ':By/:Number/:Date',
    component: FlightTrackerComponent,
    data: { pageName: 'Flight Tracker' },
  },
];

export const flightTrackerRoutes = RouterModule.forChild(routes);
